import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatLegacyCardModule as MatCardModule } from "@angular/material/legacy-card";
import { MaterialModule } from "@app/material.module";
import { SatPopoverModule } from "@ncstate/sat-popover";
import { TranslateModule } from "@ngx-translate/core";
import { DayPickerPopoverComponent } from "./day-picker-popover.component";

@NgModule({
	declarations: [DayPickerPopoverComponent],
	imports: [CommonModule, SatPopoverModule, MatCardModule, MatDatepickerModule, TranslateModule, MaterialModule],
	exports: [DayPickerPopoverComponent],
})
export class DayPickerPopoverModule {}
